// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3j5FC","rootSuccess":"CompleteLink_rootSuccess__u-EKZ","rootFailure":"CompleteLink_rootFailure__3uufF","isDisabled":"CompleteLink_isDisabled__35ayI"};